















import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Typography
  }
})
export default class TabsNavigation extends Vue {
  @Prop({ default: [] }) tabs!: { label: string; value: string }[];
  @Prop({ default: '' }) activeTab?: string;
}
